import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinimize = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 2.66667V4.66667C6 5.40305 5.40305 6 4.66667 6H2.66667M13.3333 6H11.3333C10.597 6 10 5.40305 10 4.66667V2.66667M10 13.3333V11.3333C10 10.597 10.597 10 11.3333 10H13.3333M2.66667 10H4.66667C5.40305 10 6 10.597 6 11.3333V13.3333",
		stroke: "currentColor",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMinimize;
